/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'
import { DataFormResponse } from './types'
import { useGetFilterSelections } from '@/catalog-apps/hooks/useGetFilterSelections'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { useGetPageFilters } from '../../AppPage2/Filter/useGetPageFilters'
// import { json } from '@/catalog-apps/mock-data/data-form/data-form-response-no-file.json'
import { populateDefaultFormValues } from './utils'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'
import { TComponentType } from '../../AppPage2/types'
// const dataFormResponse = json as DataFormResponse

const USE_MOCK_DATA = false

interface GetDataFormParams {
  appKey?: string
  contentId?: string
  projectId?: number
  filterSelections: Record<string, any>[]
  isPageBuilder?: boolean
  payload?: Record<string, any>
}
const getDataForm = async ({
  appKey,
  contentId,
  projectId,
  filterSelections,
  isPageBuilder,
  payload,
}: GetDataFormParams) => {
  if (!appKey || !contentId || !projectId) {
    throw new Error('Missing required parameters')
  }
  if (isPageBuilder || USE_MOCK_DATA) {
    return populateDefaultFormValues({
      ...(await import('@/catalog-apps/mock-data/data-form/data-form-response-grid-1-row.json')).json,
    } as DataFormResponse)
  }
  // return populateDefaultFormValues(dataFormResponse)
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  if (!token) {
    throw new Error('No token found')
  }
  const url = `${ENDPOINTS.CC_DOTNET}/content`
  const body = {
    app_id: appKey,
    content_id: contentId,
    project_id: projectId,
    filters: filterSelections,
  }
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(
      payload
        ? {
            ...body,
            payload: payload,
          }
        : body
    ),
  })
  const data = (await response.json()) as DataFormResponse
  if (response.ok) {
    return populateDefaultFormValues(data)
  }
  throw new Error('Failed to fetch DataForm')
}

export function useGetDataForm(
  contentId: string,
  tileFilterSelections: Record<string, any>[],
  payload?: Record<string, any>
) {
  const isPageBuilder = useIsPageBuilder()
  const {
    data: { defaultSelections },
  } = useGetPageFilters()
  const { filterSelections } = useGetFilterSelections()
  const { appKey, projectId } = useAppContext()
  const filterSelectionsArray =
    filterSelections.length > 0
      ? [...filterSelections, ...tileFilterSelections]
      : [...defaultSelections, ...tileFilterSelections]
  const componentType: TComponentType = 'data-form'
  return useSuspenseQuery({
    queryKey: [contentId, componentType, appKey, projectId, filterSelectionsArray, isPageBuilder, payload],
    queryFn: () =>
      getDataForm({ appKey, contentId, projectId, filterSelections: filterSelectionsArray, isPageBuilder, payload }),
  })
}
